module.exports = __webpack_public_path__ + "img/17.64e78abd.png";